import React, { Component } from 'react'

export default class Introduction extends Component {
    render() {
        return(
            <div>
                <section id="colorlib-hero" className="js-fullheight" data-section="home">
                    <div className="flexslider js-fullheight">
                        <ul className="slides">
                            <li style={{backgroundImage: 'url(images/background.jpg)', backgroundSize: 'cover'}}>
                                <div className="overlay"/>
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                                            <div className="slider-text-inner js-fullheight">
                                                <div className="desc">
                                                    <h1 style={{color: 'black'}}>Hi! I am<br/>Fernando</h1>
                                                    <p><a className="btn btn-primary btn-learn" href="https://drive.google.com/file/d/1B_Zy5Poskupgmcdyc0UQzvHcy5WsUY-_/view?usp=sharing" target="_blank" rel="noopener noreferrer">View CV<i className="icon-download4"/></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li style={{backgroundImage: 'url(images/background2.jpg)', backgroundSize: 'cover'}}>
                                <div className="overlay"/>
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                                            <div className="slider-text-inner js-fullheight">
                                                <div className="desc">
                                                    <h1 style={{paddingTop: '30px'}}>Professional Profile</h1>
                                                    <p><a className="btn btn-primary btn-learn" href="https://www.linkedin.com/in/fernando-winardi/" target="_blank" rel="noopener noreferrer">View LinkedIn<i className="icon-linkedin2"/></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
        )
    }
}